export const environment = {
    env: 'STAGING',
    production: true,
    API_URL: "https://api-staging.easyorderapp.com",
    EMBED_URL: "https://embed-staging.easyorderapp.com",
    SAMPLE_RATE: 1.0
};
